<fgb-banner [pageTitle]="'games.page.title'"></fgb-banner>

<fgb-page-header [pageTitle]="'games.page.title'" [backButtonLink]="'/'" />

<div class="container">
  <ng-container *inProductCode="[productCode.Free]"> <fgb-upgrade-banner></fgb-upgrade-banner></ng-container>
  <div class="game-container-sections row row-cols-1 row-cols-lg-2">
    <div>
      <div class="game-panel">
        <div class="games-card-header" [style.background-image]="'url(' + ('games/trivia.jpg' | contentAssetImage) + ')'"></div>
        <div class="card">
          <div class="game-panel-text">
            <h5 class="game-panel-title text-uppercase mb-0">{{ 'games.page.trivia' | translate }}</h5>
            <div class="game-panel-desc font-size-14">{{ 'games.page.trivia.description' | translate }}</div>
          </div>
          <div [routerLink]="'/games/trivia'">
            <div class="btn">{{ 'games.page.trivia.play' | translate }}</div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="game-panel">
        <div class="games-card-header" [style.background-image]="'url(' + ('games/polls.jpg' | contentAssetImage) + ')'"></div>
        <div class="card">
          <div class="game-panel-text">
            <h5 class="game-panel-title text-uppercase mb-0">{{ 'games.page.polls' | translate }}</h5>
            <div class="game-panel-desc font-size-14">{{ 'games.page.polls.description' | translate }}</div>
          </div>
          <div [routerLink]="'/games/polls'">
            <div class="btn">{{ 'games.page.polls.play' | translate }}</div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="game-panel">
        <div
          class="games-card-header"
          [style.background-image]="'url(' + ('games/predictor.jpg' | contentAssetImage) + ')'"
        ></div>
        <div class="card">
          <div class="game-panel-text">
            <h5 class="game-panel-title text-uppercase mb-0">{{ 'games.page.predictor' | translate }}</h5>
            <div class="game-panel-desc font-size-14">{{ 'games.page.predictor.description' | translate }}</div>
          </div>
          <div [routerLink]="'/games/predictor'">
            <div class="btn">{{ 'games.page.predictor.play' | translate }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
